import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import DialogContent from '@mui/material/DialogContent';

import AuthorizedApolloClientProvider from '../../context/AuthorizedApolloClientProvider';
import AppRouter from './AppRouter';
import CustomSpinner from '../components/LoadingScreens/CustomSpinner';
import ModalDetail from '../ModalDetail/ModalDetail';
import { loginFailed, loginNoCode, loginNoEmail } from '../../constants/accessDeniedMessages';

//const API_BASE = process.env.REACT_APP_MIDDLEWARE_API_BASE_URL || 'http://localhost:8080/';
const API_BASE = process.env.REACT_APP_MIDDLEWARE_API_BASE_URL || 'https://wfma-dev.ttec.com/';

const AuthenticatedApp = () => {
    const [email, setEmail] = useState(null);
    const [authChecked, setAuthChecked] = useState(false);
    const [loginError, setLoginError] = useState(null);

    useEffect(() => {
        console.log(`[AuthenticatedApp] AuthenticatedApp mounted — checking session via${API_BASE}api/user`);

        // Check for error params returned by /api/callback (e.g. PingID failure)
        const params = new URLSearchParams(window.location.search);
        const authError = params.get('error');
        if (authError) {
            console.error(`[AuthenticatedApp] Auth error param detected: ${authError}`);
            if (authError === 'no_code') setLoginError(loginNoCode);
            else if (authError === 'no_email') setLoginError(loginNoEmail);
            else setLoginError(loginFailed);
            return;
        }
        fetch(`${API_BASE}api/user`, {
            method: 'GET',
            credentials: 'include', // send session cookie
        })
            .then((res) => {
                if (res.status === 401) {
                    // No active session — redirect to PingID login
                    console.log(`[AuthenticatedApp] No session found (401) — redirecting to ${API_BASE}api/login`);
                    window.location.href = `${API_BASE}api/login`;
                    return null; // First-time login, not an error — intentional redirect
                }
                return res.json();
            })
            .then((data) => {
                if (!data) return; // redirect in progress
                //const emailReturned = data?.user?.upn || data?.user?.unique_name || data?.user?.email || '';
                const emailReturned = data?.user?.email || '';
                if (!emailReturned) {
                    console.error(`[AuthenticatedApp] Session user has no email claim — showing error modal`);
                    setLoginError(loginNoEmail);
                    return;
                }
                console.log(`[AuthenticatedApp] User Authenticated as: ${emailReturned}`);
                setEmail(emailReturned);
                setAuthChecked(true);
            })
            .catch((err) => {
                console.error(`[AuthenticatedApp] Error during session check — showing error modal:`, err);
                setLoginError(loginFailed);
            });
    }, []);

    const logout = () => {
        console.log(`[AuthenticatedApp] Calling ${API_BASE}api/logout to destroy session and get PingFederate logout URL.`);
        fetch(`${API_BASE}api/logout`, {
            method: 'POST',
            credentials: 'include',
        })
            .then((res) => res.json())
            .then((data) => {
                const logoutUrl = data?.logoutUrl || `${API_BASE}`;
                console.log(`[AuthenticatedApp] Session destroyed. Redirecting to logout ${logoutUrl}`);
                window.location.href = logoutUrl;
            })
            .catch((err) => {
                console.log(`[AuthenticatedApp] Redirecting to logout ${API_BASE} as there was an error during logout: `, err);
                window.location.href = API_BASE;
            });
    };

    // Show error modal if PingID login failed (breaks the infinite redirect loop)
    if (loginError) {
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={true}
            >
                <DialogContent className="dialog delete-rule">
                    <ModalDetail modalOptions={loginError} />
                </DialogContent>
            </Modal>
        );
    }

    // Wait until session check is complete before rendering the app
    if (!authChecked || !email) {
        return <CustomSpinner />;
    }

    return (
        <AuthorizedApolloClientProvider>
            <AppRouter
                email={email}
                logout={logout}
            />
        </AuthorizedApolloClientProvider>
    );
};

export default AuthenticatedApp;